import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Auth {
    memName: string;
    memId: string;
    memKey: string;
}

const initialState: Auth = {
    memName: '',
    memId: '',
    memKey: '',
}

export const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        setMemInfo: (state, action: PayloadAction<Auth>) => {
            state.memId = action.payload.memId;
            state.memName = action.payload.memName;
            state.memKey = action.payload.memKey;
        },
        logOut: state => {
            state.memId = '';
            state.memName = '';
            state.memKey = '';
            localStorage.clear()
        }
    }
});

export const { setMemInfo, logOut } = authSlice.actions;

export default authSlice.reducer;